module.exports = __webpack_public_path__ + "static/media/Inter-Thin-BETA.a493fa52.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Thin-BETA.woff
// module id = 707
// module chunks = 21